class SectionSlider extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
        this._elements = {
            mainCarousel: this.querySelector('[js-main-carousel]').swiper,
            thumbCarousel: this.querySelector('[js-tumb-carousel]').swiper
        };
        this._elements.thumbCarousel.slides.forEach((slide) => {
            slide.addEventListener('click', this._handleThumbClick.bind(this))
        });
      this._init()
    }

    _init() {
        this._elements.thumbCarousel.slides.forEach((slide) => {
            slide.classList.remove('active')
        });
        this._elements.thumbCarousel.slides[this._elements.mainCarousel.activeIndex].classList.add('active')
        console.log('this._elements.mainCarousel.activeIndex', this._elements.mainCarousel.activeIndex)

        this._elements.mainCarousel.on('slideChangeTransitionStart', this._handleMainImageChange.bind(this))
    }

    _handleMainImageChange() {
        let currentSlide

        this._elements.mainCarousel.slides.forEach((slide) => {
            if (slide.classList.contains('swiper-slide-active')) {
                currentSlide = slide
            }
        })

        const currentSlideIndex = currentSlide.dataset.swiperSlideIndex
        this._elements.thumbCarousel.slides.forEach((slide) => {
            if (slide.dataset.originalIndex == currentSlideIndex) {
                slide.classList.add('active')
            } else {
                slide.classList.remove('active')
            }
        });
    }

    _handleThumbClick(e) {
        const currentSlideIndex = +e.currentTarget.dataset.originalIndex
        this._elements.thumbCarousel.slides.forEach((slide) => {
            slide.classList.remove('active')
        });
        this._elements.mainCarousel.slideTo(currentSlideIndex)
        e.currentTarget.classList.add('active')
    }
  }

  customElements.define("s-slider", SectionSlider);